module.exports = __webpack_public_path__ + "img/open-h.c8954433.svg";